import { TrainingsContentBlockInput } from 'generated/resources/graphql'

import { AttachedFile } from 'modules/trainings/lib/content/AttachedFile'
import { PageBlock } from 'modules/trainings/lib/content/PageBlock'
import { BlockMapper } from 'modules/trainings/lib/content/mappers/graphql/BlockMapperRegistry'
import { MapperTransformationError } from 'modules/trainings/lib/content/mappers/graphql/errors'
import { GQLContentBlock } from 'modules/trainings/lib/content/mappers/graphql/types'

function isPageContentable(contentable: GQLContentBlock['contentable']): contentable is NonNullable<
  GQLContentBlock['contentable']
> & {
  __typename: 'TrainingsContentBlockPage'
  description?: string | null
  thumbnail?: { url?: string | null; filename?: string | null } | null
} {
  return contentable?.__typename === 'TrainingsContentBlockPage'
}

export const pageBlockMapper: BlockMapper<PageBlock> = {
  graphqlTypename: 'TrainingsContentBlockPage',
  blockConstructor: PageBlock,

  fromGraphQL(gqlBlock: GQLContentBlock): PageBlock {
    const contentable = gqlBlock.contentable

    if (!isPageContentable(contentable)) {
      throw new MapperTransformationError(
        'TrainingsContentBlockPage',
        `Expected TrainingsContentBlockPage, got ${contentable?.__typename || 'null'}`,
        gqlBlock
      )
    }

    return new PageBlock({
      id: gqlBlock.id,
      uuid: gqlBlock.uuid,
      title: gqlBlock.title,
      accesible: gqlBlock.accesible,
      description: contentable.description || '',
      thumbnail: new AttachedFile({
        url: contentable.thumbnail?.url || undefined,
        filename: contentable.thumbnail?.filename || undefined,
      }),
    })
  },

  toGraphQL(block: PageBlock): TrainingsContentBlockInput {
    return {
      uuid: block.uuid,
      title: block.title,
      type: 'page',
      typePage: {
        description: block.description,
        thumbnail: block.thumbnail
          ? {
              signedId: block.thumbnail.signedId,
              url: block.thumbnail.url,
            }
          : undefined,
      },
    }
  },
}
